import { action } from "typesafe-actions";
import { ChatbotSuggestion } from "../types/chat-suggestion-types";

export enum ChatSuggestionActions {
    CLEAN_SUGGESTION = "ChatSuggestionActions/CLEAN_SUGGESTION",
    UPDATE_SHOW_SUGGESTION = "ChatSuggestionActions/UPDATE_SHOW_SUGGESTION",
    SHOW_SUGGESTION = "ChatSuggestionActions/SHOW_SUGGESTION",
    QUERY_SUGGESTION_LIST = "ChatSuggestionActions/QUERY_SUGGESTION_LIST",
    FILTER_SUGGESTION_LIST = "ChatSuggestionActions/FILTER_SUGGESTION_LIST",
    SET_INPUT_ACTION = "ChatSuggestionActions/SET_INPUT_ACTION",
    CLEAR_INPUT = "ChatSuggestionActions.CLEAR_INPUT",
    SUGGESTION_INPUT = "ChatSuggestionActions/SUGGESTION_INPUT",
    SET_SHOW_SUGGESTION_FLAG = "ChatSuggestionActions/SET_SHOW_SUGGESTION_FLAG"
}


export const updateShowSuggestionAction = (payload?: boolean) => action(ChatSuggestionActions.UPDATE_SHOW_SUGGESTION, payload);
export const querySuggestionListAction = (payload?: string) => action(ChatSuggestionActions.QUERY_SUGGESTION_LIST, payload);
export const filterSuggestionListAction = (payload?: boolean, meta?: string) => action(ChatSuggestionActions.FILTER_SUGGESTION_LIST, payload, meta);
export const showSuggestionAction = (payload?: boolean, meta?: ChatbotSuggestion[]) => action(ChatSuggestionActions.SHOW_SUGGESTION, payload, meta);
export const cleanSuggestionAction = () => action(ChatSuggestionActions.CLEAN_SUGGESTION);
export const setInputAction = (payload?: string) => action(ChatSuggestionActions.SET_INPUT_ACTION, payload);
export const clearInputAction = (payload?: boolean) => action(ChatSuggestionActions.CLEAR_INPUT, payload);
export const suggestionInputAction = (payload?: string) => action(ChatSuggestionActions.SUGGESTION_INPUT, payload);
export const setShowSuggestionFlagAction = (payload?: boolean) => action(ChatSuggestionActions.SET_SHOW_SUGGESTION_FLAG, payload);